import { defineComponent, ref, openBlock, createElementBlock, createElementVNode, toDisplayString, createVNode, unref, withCtx, createTextVNode, createCommentVNode } from "vue";
import { CdrLink, CdrButton, IconXLg } from "@rei/cedar";
const _hoisted_1 = {
  key: 0,
  class: "pup-notice-container"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "pup-notice-container__text-container"
};
const _hoisted_5 = {
  class: "pup-notice-container__heading"
};
const _hoisted_6 = {
  class: "pup-notice-container__message"
};
const _hoisted_7 = {
  class: "pup-notice-container--close-icon"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PupNotice",
  props: {
    productTitle: {
      default: ""
    },
    productLink: {
      default: ""
    },
    productImage: {
      default: ""
    },
    labelText: {
      default: ""
    },
    contentMessage: {
      default: ""
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isHidden = ref(false);
    const handleCtaClick = (event) => {
      emit("metricsClick", {
        linkName: `${props.labelText.toLowerCase()}`,
        link: props.productLink,
        event
      });
    };
    const handleClosePupNoticeClick = (event) => {
      emit("metricsClick", {
        linkName: `${props.labelText.toLowerCase()}_close`,
        event
      });
      isHidden.value = !isHidden.value;
    };
    const handleImageClick = (event) => {
      emit("metricsClick", {
        linkName: `${props.labelText.toLowerCase()}_thumbnail image`,
        link: props.productLink,
        event
      });
    };
    return (_ctx, _cache) => {
      return !isHidden.value ? (openBlock(), createElementBlock("aside", _hoisted_1, [createElementVNode("a", {
        class: "pup-notice-container__link",
        href: _ctx.productLink,
        "data-ui": "pup-notice-container--link-image",
        onClick: _cache[0] || (_cache[0] = ($event) => handleImageClick($event))
      }, [createElementVNode("img", {
        class: "pup-notice-container__product-image",
        src: _ctx.productImage,
        alt: _ctx.productTitle
      }, null, 8, _hoisted_3)], 8, _hoisted_2), createElementVNode("div", _hoisted_4, [createElementVNode("p", _hoisted_5, toDisplayString(_ctx.productTitle), 1), createElementVNode("p", _hoisted_6, toDisplayString(_ctx.contentMessage), 1), createVNode(unref(CdrLink), {
        href: _ctx.productLink,
        modifier: "standalone",
        onClick: _cache[1] || (_cache[1] = ($event) => handleCtaClick($event))
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.labelText), 1)]),
        _: 1
      }, 8, ["href"])]), createElementVNode("div", _hoisted_7, [createVNode(unref(CdrButton), {
        "aria-label": "Close availability notice",
        "icon-only": true,
        onClick: _cache[2] || (_cache[2] = ($event) => handleClosePupNoticeClick($event))
      }, {
        icon: withCtx(() => [createVNode(unref(IconXLg), {
          "inherit-color": ""
        })]),
        _: 1
      })])])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PupNotice2.mjs.map
